export class NodeConnectivityBadgeElement extends HTMLElement {
    #state;
    connectedCallback() {
        this.render();
    }
    set state(value) {
        this.#state = value;
        this.render();
    }
    render() {
        const status = this.#state?.status ?? "offline";
        const label = status === "connected"
            ? `Connected · ${formatPath(this.#state?.path)}`
            : "Offline";
        this.innerHTML = `<span class="node-badge node-badge-${status}" aria-live="polite">${label}</span>`;
    }
}
function formatPath(path) {
    if (!path) {
        return "offline";
    }
    return path.replace(/-/gu, " ");
}
//# sourceMappingURL=connectivity-badge.js.map